// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-4e6f2b55] {\n  color: #ffffff;\n}[dir] .info[data-v-4e6f2b55] {\n  padding: 30px;\n  margin-top: 30px;\n  text-shadow: 0 0 30px #000000;\n}\n[dir] .background[data-v-4e6f2b55]{\n  background-size: cover !important;\n}\n", ""]);
// Exports
module.exports = exports;
